import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { CLUB_FACE_LABELS } from './';
export default defineComponent({
    name: 'ClubFaceLabel',
    props: {
        type: {
            default: 'expert',
            type: String,
        },
    },
    setup(props) {
        const css = useCssModule();
        const currentLabel = computed(() => CLUB_FACE_LABELS[props.type]);
        return {
            css,
            currentLabel,
        };
    },
});
